<div class="flex flex-col overflow-hidden mr-4">
  <p class="text-lg font-medium">{{ title }}</p>
  <mat-divider class="mt-2 mb-3"></mat-divider>
  <div class="flex flex-col gt-sm:flex-row">
    <form [formGroup]="dropdownForm">
      <div class="add-label" [formGroupName]="'newOption'">
        <div class="label">
          <mat-form-field>
            <mat-label>New Value</mat-label>
            <input matInput [formControlName]="'name'" />
            <button
              mat-icon-button
              matSuffix
              [disabled]="!dropdownForm.get('newOption').valid || !dropdownForm.get('newOption').dirty"
              (click)="addOption()"
            >
              <mat-icon [svgIcon]="'add'"></mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>

      <div class="labels" [formArrayName]="'options'">
        <div class="label flex flex-auto" *ngFor="let option of dropdownForm.get('options')['controls']">
          <mat-form-field>
            <mat-label></mat-label>
            <input matInput [formControl]="option.get('name')" readonly />
            <button mat-icon-button matSuffix (click)="delete(option)">
              <mat-icon [svgIcon]="'delete'"></mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
</div>
